/**
 * Approved German copy for the Case Studies listing page. Loaded last so it
 * overrides any earlier machine-generated case-study wording.
 */
const dict: Record<string, string> = {
  // Hero
  "Case Studies": "Fallstudien",
  "Proven Results": "Nachgewiesene Ergebnisse",
  "Explore successful campaigns, the challenges we addressed, and the results achieved for brands and marketplace sellers.":
    "Entdecken Sie erfolgreiche Kampagnen, die Herausforderungen, die wir gelöst haben, und die Ergebnisse, die wir für Marken und Marketplace-Verkäufer erzielt haben.",
  // Same copy as it reaches `tr()` from JSX, with the source line break.
  "Explore successful campaigns, the challenges we addressed, and the results achieved for\n              brands and marketplace sellers.":
    "Entdecken Sie erfolgreiche Kampagnen, die Herausforderungen, die wir gelöst haben, und die Ergebnisse, die wir für Marken und Marketplace-Verkäufer erzielt haben.",
  "12x–18x": "12x–18x",
  "Return on Ad Spend": "Return on Ad Spend",
  "5.5%–8.2%": "5,5 %–8,2 %",
  "Ad Spend Ratio": "Werbekostenquote",
  "View All Case Studies": "Alle Fallstudien ansehen",
  "All case studies": "Alle Fallstudien",

  // Shared card labels
  ROAS: "ROAS",
  "Read Case Study": "Fallstudie lesen",
  "6.7%": "6,7 %",
  "5.8%": "5,8 %",
  "5.5%": "5,5 %",
  "7.1%": "7,1 %",
  "8.2%": "8,2 %",

  // Lamobile
  "Premium Electronics": "Premium-Elektronik",
  "How Lamobile achieved 15x ROAS using promo code tracking":
    "Wie Lamobile mit Promo-Code-Tracking einen ROAS von 15x erzielte",
  "A multi-brand marketplace seller scaled premium electronics sales through promo codes and specialized affiliate partners.":
    "Ein Marketplace-Verkäufer mit mehreren Marken skalierte den Verkauf von Premium-Elektronik mithilfe von Promo-Codes und spezialisierten Affiliate-Partnern.",

  // Roborock
  "Premium Household Appliances": "Premium-Haushaltsgeräte",
  "How Roborock achieved 17x ROAS with promo code tracking":
    "Wie Roborock mit Promo-Code-Tracking einen ROAS von 17x erzielte",
  "Promo code tracking helped scale sales across the brand's leading product models while maintaining strong efficiency.":
    "Promo-Code-Tracking half dabei, die Verkäufe der führenden Produktmodelle der Marke zu skalieren und gleichzeitig eine hohe Effizienz aufrechtzuerhalten.",

  // WalkingPad
  "Fitness Electronics": "Fitness-Elektronik",
  "How WalkingPad achieved 18x ROAS with promo code tracking":
    "Wie WalkingPad mit Promo-Code-Tracking einen ROAS von 18x erzielte",
  "Affiliate partners delivered strong efficiency for a premium, high-ticket product category.":
    "Affiliate-Partner erzielten eine hohe Effizienz in einer Premium-Produktkategorie mit hohem Warenkorbwert.",

  // 70mai
  "Automotive Electronics": "Fahrzeugelektronik",
  "How 70mai achieved 14x ROAS across a broad product range":
    "Wie 70mai mit einem breiten Produktsortiment einen ROAS von 14x erzielte",
  "Promo code tracking helped generate sales across a wide range of dash cams and automotive accessories.":
    "Promo-Code-Tracking half dabei, Verkäufe über ein breites Sortiment an Dashcams und Fahrzeugzubehör zu generieren.",

  // Lexar
  "Storage Devices": "Speicherlösungen",
  "How Lexar achieved 12x ROAS in a low-ticket category":
    "Wie Lexar in einer Niedrigpreis-Kategorie einen ROAS von 12x erzielte",
  "A broad assortment of storage products generated steady sales through affiliate partners and promo codes.":
    "Ein breites Sortiment an Speicherprodukten generierte über Affiliate-Partner und Promo-Codes kontinuierliche Verkäufe.",
};

export default dict;
